import axiosInstance from "./axiosInstance";
export const fetchAllTransactions= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/transaction/lists`,{
        params:params
    });
    return {
     success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};



export const initiateServiceTransactionStatus= async (data) => {
  try {
    const response = await axiosInstance.post(`/api/admin/transaction/status/checking`,data);
    return {
     success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};



export const claimRefundApi = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/api/dmt/transaction/refund/claim",
      payload
    );
    return res.data;
  } catch (error) {
    throw error?.response?.data || {
      success: false,
      message: "Refund request failed"
    };
  }
};




export const claimRefundApiFinal = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "/api/dmt/transaction/refund/final/claim",
      payload
    );
    return res.data;
  } catch (error) {
    throw error?.response?.data || {
      success: false,
      message: "Refund request failed"
    };
  }
};